module.exports = __webpack_public_path__ + "media/images/icon-usage-c42342a3202e60d716a00378ad72ce9f.svg";